import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "upload",
  "use": "upload-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"upload\"><title>upload</title><path d=\"M7.625 1.156Q7.781 1 8 1t.375.156l2.438 2.438q.156.156.156.383t-.156.383-.375.156-.391-.156l-1.5-1.516v9.031q0 .219-.164.375T8 12.406t-.383-.156-.164-.375V2.844L5.937 4.36q-.156.156-.375.156t-.375-.156-.156-.383.156-.383zM14.445 10q-.227 0-.383.164t-.156.383v3.047q0 .141-.094.234t-.234.094H2.39q-.141 0-.234-.094t-.094-.234v-3.047q0-.219-.156-.383T1.523 10t-.383.164-.156.383v3.484q0 .406.281.688t.688.281h12.063q.406 0 .688-.289t.281-.68v-3.484q0-.219-.156-.383T14.446 10z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/upload.svg
// module id = 528
// module chunks = 0